// src/services/address.js
import http from '../lib/http';

// Get all customer addresses
export const getAddresses = () => http.get('/api/customer/customer_address');

// Get single address by ID
export const getAddress = (id) => http.get(`/api/customer/customer_address/${id}`);

// Create new address
export const createAddress = (data) => http.post('/api/customer/customer_address', data);

// Update address
export const updateAddress = (id, data) => http.put(`/api/customer/customer_address/${id}`, data);

// Delete address
export const deleteAddress = (id) => http.delete(`/api/customer/customer_address/${id}`);
